import { useSelector, useDispatch } from 'react-redux';

import { setCurrentStep } from './actions';
import Step1 from './components/steps/step1';
import Step2 from './components/steps/step2';
import Step3 from "./components/steps/step3";
import Step4 from "./components/steps/step4";

const App = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.app.currentStep);

  switch (currentStep) {
    case 1:
      return <Step1 />;
    case 2:
      return <Step2 />;
    case 3:
      return <Step3 />;
    case 4:
      return <Step4 />;
    default:
      return (
        <>
        <strong>Step:{currentStep} is not done yet :(</strong>
          <button onClick={(e) => {
            e.preventDefault();
            dispatch(setCurrentStep(1));
          }}>Return to step 1</button></>
        )
  }
};

export default App;
